import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import customersService from "services/customers.service";
import { CustomerResponse } from "types/responses.type";

interface CustomersState {
  items: CustomerResponse[];
  loading: boolean;
  error: string | null;
  page: number;
  hasMore: boolean;
}

const initialState: CustomersState = {
  items: [],
  loading: false,
  error: null,
  page: 1,
  hasMore: true,
};

export const fetchCustomers = createAsyncThunk(
  "customers/fetchCustomers",
  async (arg, { rejectWithValue }) => {
    try {
      const response = await customersService.getCustomers();
      if (!response.ok || !response.data) {
        return rejectWithValue(
          response.errorMessage || "Failed to fetch customers"
        );
      }
      console.log(`Fetched ${response.data.length} customers`);

      return { data: response.data };
    } catch (error) {
      return rejectWithValue("An unexpected error occurred");
    }
  }
);

const customersSlice = createSlice({
  name: "customers",
  initialState,
  reducers: {
    resetCustomersState: (state) => {
      state.items = [];
      state.page = 1;
      state.hasMore = true;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCustomers.fulfilled, (state, action) => {
        state.loading = false;

        state.items = action.payload.data;
      })
      .addCase(fetchCustomers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetCustomersState } = customersSlice.actions;

export default customersSlice.reducer;
